// Authentication Constants
const AuthenticationConstants = {
    CodeToken: "auth-token",
    IGToken: "auth-token-ig",
    Key: "authenticated",
    CloudCSPToken: "purecloud-csp-token",
    CloudCSPEnv: "purecloud-csp-env",
    AccessToken: "access_token",
    CodeVerifier: "genesys_cloud_sdk_pkce_code_verifier",
    ExpireIn: "expires_in",
    ExpireOn: "expires_on",
    InGCloud: "in_gcloud",
    ClientOrg: "client_org"
};
  
// GCloud Organization Constants
const OrganizationConstants = {
    UrlApps: "org-apps",
    UrlApi: "org-api",
    UrlAuth: "org-auth",
    UrlAuthShort: "org-auth-short",
    UrlPromptLogin: "org-auth-prompt-login",
    UsePopup: "org-popup",
    Language: "org-lang",
};
  
const DefaultApplicationConstants = {
    DefaultEnv: "usw2.pure.cloud",
    DefaultKBCAppId: "genesysSharepointConnector",
    HostOriginParameterKey: "gcHostOrigin",
};

const RoleConstants = {
    admin: "KBC Installation Wizard Admin",
    sharepointAdmin: "SharePoint Connector Admin",
    sharepointView: "SharePoint Connector View"
}

const StatusCodesConstants = {
    OK: 200,
    Accepted: 202,
    NoContent: 204,
    BadRequest: 400,
    Unauthorized: 401,
    Forbidden: 403,
    NotFound: 404,
    Conflict: 409,
    TooManyRequests: 429,
    InternalServerError: 500,
    ServiceUnavailable: 503,
} as const; 

const FetchWrapConstants = {
    CorrelationIdHeader: 'inin-correlation-id',
    RetryHeader: 'retry-after'
} as const;
  
export {
    AuthenticationConstants,
    OrganizationConstants,
    DefaultApplicationConstants,
    RoleConstants,
    StatusCodesConstants,
    FetchWrapConstants
};
  
  